export default __webpack_public_path__ + "static/media/ThaiSansNeue-UltraLight.7cdc119a.otf";